import FrontOfficeLinkField from './component';
import { FrontOfficeLinkFieldProps } from './types';

export default FrontOfficeLinkField;
export type { FrontOfficeLinkFieldProps };
